import React from "react";
import styles from "../agent-response.module.scss";

type InferenceWorkflowEndAgentProps = {
  parsedContent: any;
};

export default function InferenceWorkflowEndAgent({
  parsedContent,
}: InferenceWorkflowEndAgentProps): JSX.Element {
  const message = parsedContent?.question || parsedContent?.prompt || "The workflow has ended, please refresh to start a new one.";

  return (
    <div className={styles.pressReleaseContent}>
      <p>{message}</p>
    </div>
  );
}
